export { initialState as state } from './state';
export { FunnelState as IState } from '@store/funnel/interfaces/funnelState';
export { default as actions } from './actions';
export { default as mutations } from './mutations';
export const namespaced = true;
